<template>
    <div class="echart-info" v-loading='echartLoad'>
        <div class="info-echart">
            <div class="echart-tab"> 
                <div  v-for="item in echartTab" :key="item.num"> 
                    <!-- 只有中药统计显示方剂识别 ，中药属性的四气、五味、归经显示雷达图-->
                    <div v-show="item.value=='方剂识别'&&chartName=='中药'" class="tab-nav">
                        <el-button @click='echart_nav(item)'  type="primary" size="small" > {{ item.value }}</el-button> 
                    </div>
                    <div v-show="item.value=='雷达图'&&isTcm"  class="tab-nav">
                       <el-button @click='echart_nav(item)' size="small"  type="primary"> {{ item.value }}</el-button>
                    </div>
                    <div  v-show="item.value!='雷达图'&&item.value!='方剂识别'"  class="tab-nav">
                       <el-button @click='echart_nav(item)' type="primary" size="small" > {{ item.value }}</el-button>
                    </div>
                </div>
            </div>
            <!-- 统计的数量 -->
            <statisticsNum  @modify_num="modify_num"></statisticsNum>
            
        </div>
        <div class="echart-box" v-show='series_data.length!=0'>
            <div v-show="navType=='pie'" class="info" ref="echart_pie"> </div>
            <div  v-show="navType=='bar'" class="info" ref="echart_bar"> </div>
            <div  v-show="navType=='radar'" class="info" ref="echart_radar"> </div>
            <!-- <div  v-show="navType=='radar'" class="radar-text" v-html="radarInfo"></div> -->
        </div>
        <div v-show='series_data.length!=0' class="lable-info">
            调整图谱标注字体大小：<el-input size='small' style="width:140px" type='number' v-model="lableNum" placeholder="请输入字体大小" @change='numChange'><template slot="append">px</template></el-input>
        </div>
        <div v-show='series_data.length==0' class="no-echart-data">当前无数据结果</div>
        <!-- 中药属性专用table -->
        <TcmTable ref='tcm_table' v-if="chartName=='中药'"></TcmTable>
        <!-- 通用 -->
        <echartTable ref='echart_table' v-else></echartTable>
       
        <!-- 生成报告 暂不显示 -->
        <!-- <modelTip :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' @ok='report_sure' :width="'400px'" :title="'生成报告'">
            <div slot="content" >
                <el-form class="form-data">
                    <el-form-item label="文件名称："  label-width="90px">
                        <el-input v-model="reportName"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </modelTip> -->
        <reportModel  :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' :titleName='`${chartName}统计分析`' :reportList='echartList' :reportImg='reportImg'></reportModel>
    </div>
</template>

<script>
import reportModel from '../comps/report_model.vue'
import excavateData from '../comps/excavateData.js'
import echartTable from './echart_table.vue';
import TcmTable from './tcm_table.vue';
import statisticsModel from './statistics_model.vue'
import modelTip from '../../../components/ui-kit/model_tip.vue'
import statisticsNum from "./statistics_num.vue"
import {mapState,mapMutations,mapActions} from 'vuex'
import {createExport,processingData} from '../../../io/api.js'
export default {
    props: ['isRadar'],
    components: {
        echartTable ,
        TcmTable,
        statisticsModel,
        modelTip,
        statisticsNum,
        reportModel
    },
    data () {
        return {
            echartLoad:false,
            radarInfo:'',
            chartOption:{},
            myChart:'',
            echartTab:excavateData.echartTab,
            legend_data:[],
            series_data:[],
            modelData:[],
            // 生成报告
            isShowReport:false,
            opts :{
                type: 'jpeg', // 导出的格式，可选 png, jpeg
                pixelRatio: 1,// 导出的图片分辨率比例，默认为 1。
                backgroundColor: "#fff",// 导出的图片背景色，默认使用 option 里的 backgroundColor
                // excludeComponents: Array.<string>  // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox'],一般也忽略了'toolbox'这栏就够了
            },
            reportImg:'',//图标的url
            // 报名文件名称
            reportName:'',
            // radarEchart:[],
            // eacheat相关设置
            // navType:'pie',
            tooltip: {
                trigger: "item",
                backgroundColor: "rgba(0,0,0,0.8)",
                borderColor: '#333',
                textStyle: {
                    color:'#fff'
                }
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        title: '保存为图片',
                        show: true
                    }
                },
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            myChartPie:'',
            myChartBar:'',
            myChartRadar:'',
            radarTitle:'',
            lableNum:14
        }
    },

    computed: {
        ...mapState({
            isLoad:state=>state.excavate.isLoad,
            chartName:state=>state.excavate.chartName,
            echartList:state=>state.excavate.echartList,
            radarEchart:state=>state.excavate.radarEchart,
            isTcm:state=>state.excavate.isTcm,
            chartType:state=>state.excavate.chartType,
            navType:state=>state.excavate.navType,
        })
        
    },
    watch: {
        echartList(val,old){
            if(val!=old){
                this.getEcharts();
            }
        },
        // lableNum(val,old){
        //     if(val<12||val>60){
        //         this.$message.error( '图谱标注字体最小为12px～')
        //         this.lableNum=12
        //         return
        //     }
        //     if(val!=0&&val!=old){
        //         this.setEchartType('radar')
        //     } 
        // }
    },
    mounted() { 
        this.myChartPie = this.$echarts.init(this.$refs.echart_pie,'dark');
        this.myChartBar = this.$echarts.init(this.$refs.echart_bar,'dark');
        this.myChartRadar = this.$echarts.init(this.$refs.echart_radar,'dark');
        this.echartLoad=true; 
        this.$nextTick(()=>{
            this.getEcharts();
        })
    },
    methods: {
        echart_nav(item){
            // report：生成报告,recognize:方剂识别
            if(item.type=='report'){
                this.isShowReport =true;
                return
            }else if(item.type=='recognize'){ 
                let keyName=[];
                this.echartList&&this.echartList.forEach(item=>{
                    if(item.keyName){
                        keyName.push(item.keyName)
                    }
                }) 
                this.$nextTick(()=>{
                    this.$router.push({
                        path:'recognizeFj',
                        query:{
                            keyName:keyName.toString()
                        }
                    }) 
                    return
                })
                
            }
            this.$store.state.excavate.navType=item.type;
            this.setEchartType(item.type)
        },
        
        getEcharts(){

            this.echartLoad=true;
            this.legend_data=[];
            this.series_data=[];
            this.echartList&&this.echartList.forEach(item => {
                this.legend_data.push(item.keyName); 
                let obj = {
                    value:item.valueName,
                    // name:item.keyName,
                    name:item.keyName+`(${item.valueName}次)`,
                }
                // 2025.02.24 频次为0不展示
                if(item.valueName!=0){
                   this.series_data.push(obj)
                }
            });
            if(this.$refs.echart_table){
                this.$refs.echart_table.clearSort()
            }else if(this.$refs.tcm_table){
                this.$refs.tcm_table.clearSort()
            }
            this.setEchartType(this.navType)
        },
        // 图表类型
        setEchartType(type){
            // this.reportImg =''; 
            this.echartLoad=false; 
            if(type=='pie'){
                this.setEcharts_pie()
            }else if(type=='bar'){
                this.setEcharts_bar()
            }else if(type=='radar'){
               this.setEcharts_radar();
            }
        },
        //饼图
        setEcharts_pie(){
            let chartOption ={
                title: {
                    text:this.chartName+'分布图',
                    left: 'center'
                },
                tooltip: this.tooltip,
                toolbox: this.toolbox,
                // legend: {
                //     type: 'scroll',
                //     bottom: 'bottom',
                //     data: this.legend_data,
                //     selected:this.legend_data


                // }, 
                series: [{
                    animation:false,
                    name: '频次',
                    type: 'pie',
                    radius: '50%',
                    center: ['50%', '50%'],
                    data: this.series_data,
                    label: {
                        normal: {
                            // show: true,
                            // formatter: '{b}({d}%)' //自定义显示格式(b:name, c:value, d:百分比)
                            textStyle:{
                                fontSize:this.lableNum
                            }
                        },
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                            
                        }
                    }
                }],
            };
            this.myChartPie.setOption(chartOption);
            this.reportImg  =this.myChartPie.getDataURL(this.opts) 

        },
        //柱状图
        setEcharts_bar(){
            let chartOption ={
                title: {
                    text:this.chartName+'分布图',
                    left: 'center'
                },
                tooltip: this.tooltip,
                toolbox: this.toolbox,
                xAxis: [
                    {
                        type: 'category',
                        data: this.legend_data,
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            // rotate: -45, //倾斜度 -90 至 90 默认为0
                            margin: 5, //刻度标签与轴线之间的距离
                            // textStyle: {
                            fontSize: this.lableNum, //横轴字体大小
                            // // color: "#000000",//颜色
                            // },
                        },
                    },
                    
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [{
                    name: '频次',
                    type: 'bar',
                    animation:false,
                    data: this.series_data,
                    markPoint: {
                        symbol: "pin",
                        symbolSize: "56",
                        symbolOffset: [0, -1],
                        
                        label: {
                            fontSize: 14
                        },

                        // data: [
                        //     { type: "max", name: "最大值" },
                        //     { type: "min", name: "最小值" },
                        // ],
                    },
                    itemStyle: {        //上方显示数值
                        normal: {
                            label: {
                                show: true, //开启显示
                                position: 'top', //在上方显示
                                textStyle: { //数值样式
                                    color: '#dd6b66',
                                    fontSize: 14,
                                }
                            }
                        }
                    }
                }],
            };
            this.myChartBar.setOption(chartOption);
            this.reportImg  =this.myChartBar.getDataURL(this.opts) 
        },
        // 雷达图
        setEcharts_radar(){
            let echartData=[];
            let seriesData=[];
            let arr = []
            let num=-1;
            let maxNum =0;
            this.echartList.forEach((item,index)=>{
                // 最大值
                if(num<Number(item.valueName)){
                    num = item.valueName;
                    maxNum = Math.ceil(num/10)*10;
                }
                let obj={
                    name:item.keyName,
                    type:Number(item.valueName),
                    max:maxNum
                }
                if(index==0){
                    obj.axisLabel={show: true}
                }
                seriesData.push(obj.type);
                let radarHtml = `<span>${obj.name}:${obj.type}</span>`
                arr.push(radarHtml)
                echartData.push(obj)
            })
            this.radarInfo = arr.toString();

            let chartOption = {
                title: {
                    text: `${this.chartName}雷达图`,
                    left: 'center'
                },
                // legend: {
                //     orient: 'vertical',
                //     bottom: 'bottom',
                //     data: echartData1
                // },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    borderColor: '#333',
                    textStyle: {
                        color:'#fff'
                    }
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {
                            title: '保存为图片',
                            show: true
                        }
                    },
                },
                legend: {
                    // data: ['数据']
                },
                radar: {
                    indicator:echartData, 
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#666',
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        // 设置坐标轴标签的样式和内容
                        color: '#666',
                        fontSize: 14,
                        fontWeight: 'bold',
                        interval:5000,
                    },
                    // 坐标文字大小
                    name:{
                        fontSize:this.lableNum,
                        formatter: function (params, ticket) { 
                            return `${params}：(${ticket.type}次)`;
                            // return `${params}：`+ `{a|${ticket.type}次}`;
                        },
                        // rich: {
                        //     a: {
                        //         align: 'center',fontWeight: 'bold',color: '#f75454',fontSize:this.lableNum
                        //     }
                        // },
                        textStyle: {   //全局字体样式
                            fontWeight: 'bold', 
                            // fontSize: remToPx(0.75),
                        },
                    }
                },
                series: [
                    {
                        name: this.chartName,
                        animation:false,
                        type: 'radar',
                        symbol: 'circle',
                        symbolSize: 12,
                        data: [
                            {
                                value:seriesData,  
                                // // 显示数值：
                                // label:{
                                //     normal:{
                                //         show:true,
                                //         textStyle:{  //更改数值样式
                                //             color:'#f75454',
                                //             fontSize: 16,
                                //             fontWeight:'blod'
                                //         } ,
                                //         formatter:function(params){
                                //             return params.value
                                //         }
                                //     }
                                // }
                            },
                        ]
                    },
                ]
            }
            this.myChartRadar.setOption(chartOption)
            this.reportImg  =this.myChartRadar.getDataURL(this.opts) 

            
        },
        numChange(e){ 
            console.log(e)
            if(this.lableNum<12 ){
                this.$message.error( '图谱标注字体最小为12px～')
                this.lableNum=12
                return
            }
            if(this.lableNum>40 ){
                this.$message.error( '图谱标注字体最大为40px～')
                this.lableNum=40
                return
            }
            // if(val!=0&&val!=old){
                this.setEchartType(this.navType)
            // } 
        },
        // 统计个数
        modify_num(val){
            this.$emit('getInfo')
        },
        // 生成报告
        report_sure(){
            if(this.reportName==''){
                this.$message.error('请输入文件名称');
                return
            }
            let params={
                efileName:this.reportName,
                // eimg:this.analysis_srcList.concat(this.cluster_srcList),
                // etitle:`${this.eTitle}-K-Means聚类`,
                // elist:this.k_table,
            }
            createExport(params).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    // commit('setToast',{type:'success',info:data.msg||'保存成功'})
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }
                this.isShowReport = false;
            })
        },
    }

}
</script>
<style lang="less" scoped>
.echart-box{
    width: 100%; 
}
.lable-info{
    font-size: 14px;
    font-weight: bold;
    // display: flex;
    // justify-content: flex-start
}
.no-echart-data{
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin-top: 20px;
}
</style>